export const NO_ERRORS = { __errors: [] };

export const shouldDeferError = ({ interacted, submitAttempted }) =>
  !(interacted || submitAttempted);

export const suppressErrorProps = props => {
  const next = {
    ...props,
    errorSchema: NO_ERRORS,
    rawErrors: [],
    error: undefined,
  };

  if (next.formContext) {
    next.formContext = { ...next.formContext, submitted: false };
  }

  if (next.childrenProps) {
    next.childrenProps = {
      ...next.childrenProps,
      errorSchema: NO_ERRORS,
      rawErrors: [],
      formContext: next.childrenProps.formContext
        ? { ...next.childrenProps.formContext, submitted: false }
        : next.childrenProps.formContext,
    };
  }

  return next;
};

export const attachDeferralListeners = (
  node,
  { onInteract, onSubmitAttempt },
) => {
  if (!node) {
    return () => {};
  }

  const handleFocusOut = () => onInteract();
  node.addEventListener('focusout', handleFocusOut);

  const captureOpts = { capture: true };
  const form = typeof node.closest === 'function' ? node.closest('form') : null;
  const handleSubmit = () => onSubmitAttempt();
  if (form) {
    form.addEventListener('submit', handleSubmit, captureOpts);
  }

  return () => {
    node.removeEventListener('focusout', handleFocusOut);
    if (form) {
      form.removeEventListener('submit', handleSubmit, captureOpts);
    }
  };
};
